<div class="popup modal-header d-inline-block pb-0 w-100 m-auto">
  <div class="pop-up-header p-4 border-bottom d-flex justify-content-between w-100">
    <h2>Edit Document</h2>
    <fa-icon [icon]="icons.close" (click)="close()" class="icon"></fa-icon>
  </div>

  <form [formGroup]="documentForm" class="p-4">
    <!-- Document Country -->
    <div class="form-group mb-3">
      <label class="form-label">Document Country<span class="text-danger">*</span></label>
      <div class="country-dropdown-wrapper">
        <div class="country-select" (click)="toggleCountryDropdown()" [class.active]="showCountryDropdown">
          <div class="country-select__value">
            <img *ngIf="selectedCountry" [src]="getCountryFlagUrl(selectedCountry)" (error)="onFlagError($event, selectedCountry.code)" class="country-flag" [alt]="selectedCountry.name + ' flag'">
            <span [class.placeholder]="!selectedCountry">{{ selectedCountry ? selectedCountry.name : 'Select country' }}</span>
          </div>
          <fa-icon [icon]="icons.chevronDown" class="chevron" [class.open]="showCountryDropdown"></fa-icon>
        </div>
        <div class="country-dropdown" *ngIf="showCountryDropdown">
          <div class="search-box">
            <fa-icon [icon]="icons.search" class="search-icon"></fa-icon>
            <input type="text" [(ngModel)]="countrySearch" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterCountries()" placeholder="Search country..." autocomplete="off">
          </div>
          <ul class="country-list">
            <li *ngFor="let c of filteredCountries" (click)="selectCountry(c)" [class.selected]="selectedCountry?.code === c.code">
              <img [src]="getCountryFlagUrl(c)" (error)="onFlagError($event, c.code)" class="country-flag" [alt]="c.name + ' flag'">
              <span class="country-name">{{ c.name }}</span>
            </li>
            <li *ngIf="filteredCountries.length === 0" class="no-results">No countries found</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Document Type -->
    <div class="form-group mb-3">
      <label class="form-label">Document Type<span class="text-danger">*</span></label>
      <select class="form-control" formControlName="type">
        <option value="" disabled>Select type of document</option>
        <option *ngFor="let docType of documentTypes" [value]="docType">{{ docType }}</option>
      </select>
    </div>

    <!-- First Name / Last Name -->
    <div class="row mb-3">
      <div class="col-6">
        <label class="form-label">First Name in the document<span class="text-danger">*</span></label>
        <input type="text" class="form-control" formControlName="first_name" placeholder="John" (blur)="checkNameMismatch()">
      </div>
      <div class="col-6">
        <label class="form-label">Last Name in the document<span class="text-danger">*</span></label>
        <input type="text" class="form-control" formControlName="last_name" placeholder="Sand" (blur)="checkNameMismatch()">
      </div>
    </div>
    <div *ngIf="nameMismatchWarning" class="alert alert-warning d-flex align-items-center gap-2 mb-3 py-2 px-3">
      <fa-icon [icon]="icons.warn"></fa-icon>
      <small>{{ nameMismatchWarning }}</small>
    </div>

    <!-- ID Number -->
    <div class="form-group mb-3">
      <label class="form-label">ID Number<span class="text-danger">*</span></label>
      <input type="text" class="form-control" formControlName="id_number" placeholder="A12345678" maxlength="30">
      <small class="text-danger" *ngIf="documentForm.get('id_number')?.touched && documentForm.get('id_number')?.errors?.idNumberLength">
        ID number must be between 5 and 30 characters.
      </small>
      <small class="text-danger" *ngIf="documentForm.get('id_number')?.touched && documentForm.get('id_number')?.errors?.idNumberFormat">
        ID number format is invalid for the selected document type and country.
      </small>
    </div>

    <!-- Issue Date -->
    <div class="form-group mb-3">
      <label class="form-label">Issue Date</label>
      <input type="date" class="form-control" formControlName="issue_date">
      <small class="text-danger" *ngIf="documentForm.get('issue_date')?.touched && documentForm.get('issue_date')?.errors?.issueFuture">
        Issue date cannot be in the future.
      </small>
      <small class="text-danger" *ngIf="documentForm.get('issue_date')?.touched && documentForm.get('issue_date')?.errors?.issueAfterExpiry">
        Issue date must be before the expiry date.
      </small>
    </div>

    <!-- Expiration Date -->
    <div class="form-group mb-4">
      <label class="form-label">Expiration Date<span class="text-danger">*</span></label>
      <input type="date" class="form-control" formControlName="expiry_date" placeholder="DD / MM / YYYY">
      <small class="text-danger" *ngIf="documentForm.get('expiry_date')?.touched && documentForm.get('expiry_date')?.errors?.expiryPast">
        Expiry date must be in the future.
      </small>
      <small class="text-danger" *ngIf="documentForm.get('expiry_date')?.touched && documentForm.get('expiry_date')?.errors?.expiryTooSoon">
        Expiry date must be at least 6 months from today.
      </small>
      <small class="text-danger" *ngIf="documentForm.get('expiry_date')?.touched && documentForm.get('expiry_date')?.errors?.expiryTooFar">
        Expiry date cannot exceed 20 years from today.
      </small>
    </div>
  </form>

  <div class="footer p-4 d-flex gap-3">
    <button class="btn btn-cancel" (click)="close()">Cancel</button>
    <button class="btn btn-save" [disabled]="documentForm.invalid" (click)="saveChanges()">Save Changes</button>
  </div>
</div>
